import { t } from "@/i18n-js/instance";

export const RESULTS_PER_PAGE = 10;

export const TABS = {
  ALL: "all",
  ACTIVE: "active",
  CANCELED: "canceled",
} as const;

export type TabType = (typeof TABS)[keyof typeof TABS];

export const TABS_LOCALE: Record<TabType, string> = {
  [TABS.ALL]: t("settings.paywalls_admin_dashboard.subscriptions.tabs.all"),
  [TABS.ACTIVE]: t(
    "settings.paywalls_admin_dashboard.subscriptions.tabs.active",
  ),
  [TABS.CANCELED]: t(
    "settings.paywalls_admin_dashboard.subscriptions.tabs.canceled",
  ),
};
